import { useState } from "react";
import { KeyRound } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Button, Input } from "../../components/ui";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    // Endpoint always responds success to avoid email enumeration.
    await api("/auth/forgot-password", { body: { email: email.trim() } }).catch(() => {});
    setSent(true);
    setBusy(false);
  }

  return (
    <div className="flex min-h-[70vh] flex-col justify-center px-6">
      <div className="mx-auto w-full max-w-sm space-y-6 text-center">
        <div>
          <KeyRound size={48} strokeWidth={1.25} className="mx-auto text-white/40" />
          <h1 className="mt-3 font-display text-xl font-bold">Reset password</h1>
        </div>
        {sent ? (
          <>
            <p className="text-xs leading-relaxed text-white/60">
              If an account exists for <span className="font-semibold text-white">{email}</span>, a reset link is
              on its way. Check your inbox (and spam).
            </p>
            <Link to="/login">
              <Button variant="outline" className="w-full">
                Back to sign in
              </Button>
            </Link>
          </>
        ) : (
          <form className="space-y-3" onSubmit={submit}>
            <Input
              type="email"
              placeholder="Your account email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button type="submit" className="w-full" disabled={busy}>
              {busy ? "Sending…" : "Send reset link"}
            </Button>
            <Link to="/login" className="block text-xs text-white/50">
              Back to sign in
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
